import { Box, Divider, Link, Typography } from '@mui/material';
import Logo from '/assets/logo/logo_green.svg';
import {
  StyledLoginFooter,
  StyledMainContainer,
  StyledSubContainer,
} from './Login.style';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getParamValue } from '~/utils/helper/route';
import { DEVICE, useDevice } from '~/utils/hook/useDevice';
import { routePath } from '~/utils/constants';
import { useGetNotificationImagesQuery } from '~/api/oneBoxV2';
import { ImageCarousel } from '~/components/Global/ImageCarousel';
import { OnePass } from '~/components/Login/OnePass';
import { MoeEntrance } from '~/components/Login/MoeEntrance';
import { LoginForm } from '~/components/Login/LoginForm';
import { useSelector } from 'react-redux';
import { getterNotifyImage } from '~/store/notify/notifyGetter';
import { ONEPASS_STATUS } from '~/components/Login/Login.type';
import { useCommon } from '~/utils/hook/useCommon';

export const Login = () => {
  const { search } = useLocation();
  const { id } = getParamValue(search.slice(1));
  const { device } = useDevice();
  const navigate = useNavigate();
  const { copyRightAlert } = useCommon();
  const [onePassStatus, setOnePassStatus] = useState<ONEPASS_STATUS>(
    ONEPASS_STATUS.NON,
  );

  useGetNotificationImagesQuery();
  const images = useSelector(getterNotifyImage);

  useEffect(() => {
    if (
      (onePassStatus === ONEPASS_STATUS.success ||
        onePassStatus === ONEPASS_STATUS.ERROR) &&
      !id
    ) {
      navigate(routePath.resource, { replace: true });
    }
  }, [onePassStatus, id, navigate]);

  // 普通登入情況 ONEPASS_STATUS.NON && !id
  // onePass 登入情況 ONEPASS_STATUS.NON && id
  // onePass 成功登入結果 ONEPASS_STATUS.success && id
  // onePass 失敗登入結果 ONEPASS_STATUS.ERROR && id

  return (
    <>
      <StyledMainContainer>
        <StyledSubContainer type="advertise">
          <img
            src={Logo}
            alt="logo"
            style={{ width: '181px', cursor: 'pointer' }}
            onClick={() => navigate(routePath.home)}
          />
          <ImageCarousel imgList={images} />
        </StyledSubContainer>
        <Divider orientation="vertical" flexItem />
        <StyledSubContainer type="input">
          <MoeEntrance />
          <Divider />
          <LoginForm setOnePassStatus={setOnePassStatus} />
          {!id && device === DEVICE.DESKTOP && (
            <>
              <Divider />
              <OnePass
                setStatus={(status: ONEPASS_STATUS) => {
                  setOnePassStatus(status);
                }}
              />
            </>
          )}
        </StyledSubContainer>
      </StyledMainContainer>
      <StyledLoginFooter
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '8px',
          height: 'auto',
          py: 2,
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          {/* Desktop */}
          <Typography
            variant="body1"
            sx={{
              display: 'block',
              '@media (max-width: 768px)': { display: 'none' },
            }}
          >
            南一書局企業股份有限公司 Copyright © {new Date().getFullYear()} NAN
            I BOOK ENTERPRISE CO., LTD. All Rights Reserved.
          </Typography>
          {/* Tablet */}
          <Typography
            variant="body1"
            sx={{
              display: 'none',
              '@media (max-width: 768px)': { display: 'block' },
              '@media (max-width: 480px)': { display: 'none' },
            }}
          >
            南一書局企業股份有限公司
            <br />
            Copyright © {new Date().getFullYear()} NAN I BOOK ENTERPRISE CO.,
            LTD. All Rights Reserved.
          </Typography>
          {/* Mobile */}
          <Typography
            variant="body1"
            sx={{
              display: 'none',
              '@media (max-width: 480px)': { display: 'block' },
            }}
          >
            南一書局企業股份有限公司 Copyright
            <br />© {new Date().getFullYear()} NAN I BOOK ENTERPRISE CO., LTD.
            <br />
            All Rights Reserved.
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          {/* Desktop & Tablet Links */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              '@media (max-width: 480px)': { display: 'none' },
            }}
          >
            <Link
              variant="body1"
              href="https://docs.nani.com.tw/pricing-licensing/index.html"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
              數位教學服務授權金額與服務條款
            </Link>
            <Typography variant="body1" component="span">
              |
            </Typography>
            <Typography
              variant="body1"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={copyRightAlert}
            >
              版權聲明
            </Typography>
            <Typography variant="body1" component="span">
              |
            </Typography>
            <Link
              variant="body1"
              sx={{ userSelect: 'none', cursor: 'pointer' }}
              href="https://cdn.nani.cool/download/%E5%8D%97%E4%B8%80%E9%81%A0%E7%AB%AF%E9%80%A3%E7%B7%9A.exe"
              title="以 TeamViewer 進行遠端連線"
              download
            >
              遠端連線
            </Link>
          </Box>

          {/* Mobile Links */}
          <Box
            sx={{
              display: 'none',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
              '@media (max-width: 480px)': { display: 'flex' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Link
                variant="body1"
                href="https://docs.nani.com.tw/pricing-licensing/index.html"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                數位教學服務授權金額與服務條款
              </Link>
              <Typography variant="body1" component="span">
                |
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography
                variant="body1"
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={copyRightAlert}
              >
                版權聲明
              </Typography>
              <Typography variant="body1" component="span">
                |
              </Typography>
              <Link
                variant="body1"
                sx={{ userSelect: 'none', cursor: 'pointer' }}
                href="https://cdn.nani.cool/download/%E5%8D%97%E4%B8%80%E9%81%A0%E7%AB%AF%E9%80%A3%E7%B7%9A.exe"
                title="以 TeamViewer 進行遠端連線"
                download
              >
                遠端連線
              </Link>
            </Box>
          </Box>
        </Box>
      </StyledLoginFooter>
    </>
  );
};
